export default __webpack_public_path__ + "static/cruise-2290066d8b8a8295f8b00c13df6dd8ff.jpg";